import * as React from 'react';
import { observer } from 'mobx-react';
import { Col, Row } from 'antd';

import { TextView } from 'src/core/ui/text.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { AgentEditorController } from '../../parts/agent-editor.controller';
import { CurrencyEditorController } from 'src/app/general/currencies/parts/currency-editor.controller';
import { BooleanView } from '../../../../../core/ui/boolean.view';

interface Props extends ComponentViewProps<AgentItem> {
	isNew: boolean;
	mode: ControlMode;
	currency: CurrencySummary;
	onChangeCurrency: (currency: CurrencySummary) => void;
}

@observer
export class AgentGeneralPartView extends React.Component<Props, {}> {
	constructor(props) {
		super(props);
	}

	render() {
		const { model, isNew, mode, currency, onChangeCurrency } = this.props;
		const translations = (model as any).dynamicProperties['translations'];
		const array: TabLanguageModel[] = [
			{
				title: 'Description',
				dynamicProperties: translations,
				rows: 5
			}
		];
		const currencySymbol = currency != null
			? currency.symbol
			: isNew ? '$' : '';

		return (
			<Row gutter={16}>
				<Col xs={24}>
					<TextView
						required
						mode={mode}
						onGetErrorMessage={() => this.props.model.validate(false, 'name')}
						label="Name"
						value={model.name}
						onChanged={newVal => model.name = newVal}
					/>
				</Col>
				<Col xs={24}>
					<CurrencyEditorController
						required
						label="Currency"
						mode={mode}
						onChange={(item) => {
							if (item != null) {
								model.currencyId = item.id;
								onChangeCurrency(item);
							}
						}}
						value={model.currencyId}
						setBusy={this.props.setBusy}
					/>
					</Col>
				<Col span={24}>
					<TabLanguageController
						model={model}
						dynamicProperties={array}
						mode={this.props.mode}
						setBusy={this.props.setBusy}
						isRichTextBox={false}
					/>
				</Col>
				<Col span={24}>
					<TextView
						required
						mode={model.canHaveCredit ? mode : "display"}
						onGetErrorMessage={() => this.props.model.validate(false, 'creditNumber')}
						label="Credit number"
						value={model.creditNumber}
						onChanged={newVal => model.creditNumber = newVal != null ? parseFloat(newVal) : newVal}
						suffix={currencySymbol}
						addonBefore={<BooleanView value={model.canHaveCredit} mode={mode} size="small" onChanged={newVal => model.canHaveCredit = newVal} label={null} />}
					/>
				</Col>
				<Col span={24}>
					<AgentEditorController
						setBusy={this.props.setBusy}
						mode={mode}
						value={model.responsibleAgentId}
						distinctFrom={model.id}
						onChanged={newVal => model.responsibleAgentId = newVal ? newVal.id : null}
						label="Responsible agent"
					/>
				</Col>
				<Col span={24}>
					<UserEditorController
						required
						isRole={false}
						onGetErrorMessage={() => this.props.model.validate(false, 'managedById')}
						setBusy={this.props.setBusy}
						mode={mode}
						value={model.managedById}
						onChanged={newVal => model.managedById = newVal ? newVal.id : undefined}
						label="Managed by"
					/>
				</Col>
				<Col span={24}>
					<BooleanView
						value={model.dynamicProperties["isATOL"]}
						mode={mode}
						onChanged={newVal => model.dynamicProperties["isATOL"] = newVal} label="Is ATOL Operator" />
					</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agents/form/parts/agent-general.view.tsx